export enum AddContactGroupByEmailTrigger {
  ADD_CUSTOMER = 'add-customer',
  ADD_VENDOR = 'add-vendor',
}

export enum ContactGroupMode {
  CREATE_NEW = 'create-new',
  SELECT_EXISTING = 'select-existing',
}
